<div class="fixActionRow">
  <div mat-dialog-title>
    ประเภทคิว
  </div>
  <mat-dialog-content class="mat-typography">
    <form #form [formGroup]="fg">
      ข้อมูลทั่วไป
      <br>
      <mat-form-field class="short-input">
        <mat-label>หมายเลขประเภทคิว</mat-label>
        <input matInput type="number" formControlName="queueTypeId">
        <mat-error *ngIf="fg.get('queueTypeId').hasError('duplicateQueueTypeId')">
          หมายเลขนี้มีการใช้งานแล้ว
        </mat-error>

    </mat-form-field>
    <br>
    ​( <mat-form-field class="short-short-input">
      <mat-label>อักษรนำหน้า</mat-label>
      <input matInput type="text" formControlName="queueTypePrefix">
      <mat-error *ngIf="fg.get('queueTypePrefix').hasError('duplicatePrefix')">
        ถูกใช้งานแล้ว
      </mat-error>
    </mat-form-field> )

      <mat-form-field class="short-input">
        <mat-label>หมายเลขเริ่มต้น</mat-label>
        <span matPrefix class="prefix-text">{{ fg.get('queueTypePrefix').value }}</span>
        <input matInput type="number" formControlName="initialQueueNumber" [errorStateMatcher]="invalidRangeMatcher">
        <mat-error *ngIf="fg.hasError('overlabQueueNumber')">
          หมายเลขทับซ้อนกับคิวประเภทอื่น
        </mat-error>
      </mat-form-field>
      &nbsp; ถึง &nbsp;
      <mat-form-field class="short-input">
        <mat-label>หมายเลขสิ้นสุด</mat-label>
        <span matPrefix class="prefix-text">{{ fg.get('queueTypePrefix').value }}</span>
        <input matInput type="number" formControlName="endQueueNumber" [errorStateMatcher]="invalidRangeMatcher">
        <mat-error *ngIf="fg.hasError('overlabQueueNumber')">
          หมายเลขทับซ้อนกับคิวประเภทอื่น
        </mat-error>
        <mat-error *ngIf="fg.hasError('invalidRangeQueueNumber')">
          หมายเลขสิ้นสุดต้องมากกว่าเริ่มต้น
        </mat-error>
      </mat-form-field>
      <ng-container *ngIf="!fg.get('isOnlineBookingAllowed').value" >
        <br>
        <mat-form-field class="short-input">
          <mat-label>หมายเลขเริ่มต้นคิวด่วน</mat-label>
          <span matPrefix class="prefix-text">{{ fg.get('queueTypePrefix').value }}</span>
          <input matInput type="number" formControlName="fastTrackInitialQueueNumber"
            [errorStateMatcher]="invalidFastTrackRangeMatcher">
          <mat-error *ngIf="fg.hasError('fastTrackInitLessThanInit')">
            ต้องไม่น้อยกว่าหมายเลขเริ่มต้น
          </mat-error>
        </mat-form-field>
        &nbsp; ถึง &nbsp;
        <mat-form-field class="short-input">
          <mat-label>หมายเลขสิ้นสุดคิวด่วน</mat-label>
          <span matPrefix class="prefix-text">{{ fg.get('queueTypePrefix').value }}</span>
          <input matInput type="number" formControlName="fastTrackEndQueueNumber"
            [errorStateMatcher]="invalidFastTrackRangeMatcher">
          <mat-error *ngIf="fg.hasError('fastTrackEndMoreThanEnd')">
            ต้องไม่มากกว่าหมายเลขสิ้นสุด
          </mat-error>
          <mat-error *ngIf="fg.hasError('invalidFastTrackRangeQueueNumber')">
            หมายเลขสิ้นสุดต้องมากกว่าเริ่มต้น
          </mat-error>
        </mat-form-field>
      </ng-container>
      <br>
      <mat-divider></mat-divider>
      <br>
      การจองคิวออนไลน์
      <br>
      <ng-container *ngIf="selectedQueueType && selectedQueueType.isOnlineBookingAllowed">
        <mat-slide-toggle matTooltip="การปิดจะทำให้การจอง online ที่มีอยู่ไม่สามารถใช้งานได้"
          formControlName="isOnlineBookingAllowed" color="primary" (change)="toggleOnlineForm()">
          <span *ngIf="fg.get('isOnlineBookingAllowed').value" class="enabled"> เปิดการให้จองออนไลน์</span>
          <span *ngIf="!fg.get('isOnlineBookingAllowed').value" class="disabled"> ไม่เปิดการให้จองออนไลน์</span>
        </mat-slide-toggle>
        <div class="warn-box" *ngIf="!fg.get('isOnlineBookingAllowed').value">
          การปิดจะทำให้การจอง online ที่มีอยู่ไม่สามารถใช้งานได้
        </div>
      </ng-container>
      <ng-container *ngIf="!(selectedQueueType && selectedQueueType.isOnlineBookingAllowed)">
        <mat-slide-toggle formControlName="isOnlineBookingAllowed" color="primary" (change)="toggleOnlineForm()">
          <span *ngIf="fg.get('isOnlineBookingAllowed').value" class="enabled"> เปิดการให้จองออนไลน์</span>
          <span *ngIf="!fg.get('isOnlineBookingAllowed').value" class="disabled"> ไม่เปิดการให้จองออนไลน์</span>
        </mat-slide-toggle>
      </ng-container>

      <br>
      <ng-container *ngIf="otherOnline">
        มีการเปิดใช้การจองคิวออนไลน์ที่ประเภทอื่นแล้ว
      </ng-container>
      <ng-container *ngIf="noConsent">
        ยังไม่มีเอกสารยินยอมสำหรับการจองออนไลน์
      </ng-container>
      <ng-container *ngIf="fg.get('isOnlineBookingAllowed').value">
        <mat-form-field class="short-input">
          <mat-label>จำนวนที่เปิดให้จอง</mat-label>
          <input matInput type="number" min="1" formControlName="obMaxReservedQueues">
          <!-- <mat-error *ngIf="fg.get('queueTypeId').hasError('duplicateQueueTypeId')">
        หมายเลขนี้มีการใช้งานแล้ว
      </mat-error> -->
        </mat-form-field>
      </ng-container>
    </form>

    <mat-selection-list dense (selectionChange)="selectionChange($event.option)"
      *ngIf="fg.get('isOnlineBookingAllowed').value" [disabled]="!fg.get('isOnlineBookingAllowed').value">
      <span [class.disabled]="!fg.get('isOnlineBookingAllowed').value">ช่วงที่เปิดให้จองออนไลน์</span>
      <mat-error *ngIf="fg.hasError('noTimeSlot')">
        ไม่ได้เลือกเวลาที่เปิดให้จอง
      </mat-error>
      <ng-container *ngFor="let slot of checkSlots; let i=index;">
        <mat-list-option color="primary" checkboxPosition="before" [value]="slot" [(selected)]="slot.check">
          <span>{{ formatSlot(slot) }}</span>
        </mat-list-option>
      </ng-container>
    </mat-selection-list>
  </mat-dialog-content>

  <div class="spacer"></div>
  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>ยกเลิก</button>
    <button mat-raised-button color="warn" mat-dialog-close="deleted" *ngIf="selectedIndex!==-1">ลบประเภทคิว</button>
    <button mat-raised-button class="submit-button" (click)="saveQueueType()" cdkFocusInitial>บันทึก</button>
  </mat-dialog-actions>
</div>
